import { VOMelodyNote } from "../model/DataStructure.js";

export interface MelodyPlayerOptions {
    virtual?: MelodyPlayerListener;
    visual?: MelodyPlayerListener;
    notes?: VOMelodyNote[];
}

export type MelodyPlayerState = "paused" | "playing";

export interface MelodyPlayerListener {
    trigger(note: VOMelodyNote, notes: VOMelodyNote[], time: number): void;
}

export class MelodyPlayer {

    public onTime = e5.Signal.create<[{
        time: number;
        duration: number;
        player: MelodyPlayer;
    }]>();

    public onComplete = e5.Signal.create<[{
        player: MelodyPlayer;
    }]>();

    public onNote = e5.Signal.create<[{
        note: VOMelodyNote;
        time: number;
    }]>();

    private _options: MelodyPlayerOptions;
    private _notes: VOMelodyNote[] = null;
    private _startOffset: number = 0;
    private _startTime: number = 0;
    private _part: Tone.Part;
    private _virtual: MelodyPlayerListener = null;
    private _visual: MelodyPlayerListener = null;
    private _state: MelodyPlayerState = "paused";
    private _duration: number = 0;

    constructor(options: MelodyPlayerOptions) {

        this._options = e5.object.merge({

        }, options);

        this._virtual = this._options.virtual;
        this._visual = this._options.visual;

        this._part = new Tone.Part(((time, note: any) => {

            this.onNote.dispatch({
                note: note,
                time: time as number
            });

            // console.log(
            //     note.index,
            //     note.name,
            //     // time
            //     // time, 
            //     // (note.time + note.dur).toFixed(2),
            //     // Tone.now() - Number(time), 
            //     // time - startTime, 
            //     // (Tone.now() - startTime).toFixed(2),
            //     // Tone.Transport.seconds - startTime
            //     // part.humanize,
            //     // part.startOffset,
            // );

            if (this._virtual) {
                this._virtual.trigger(note, this._notes, time as number);
            }

            if (this._visual) {
                this._visual.trigger(note, this._notes, time as number);
            }
        }),
            []
        );

        e5.Player.onTick.add(() => {

            if (this._state === "playing") {
                if (this.time >= this.duration - 0.1) {
                    // console.log("LOOP");
                    // this.time = 0;
                    
                    // console.log("COMPLETE");

                    this.onTime.dispatch({
                        duration: this.duration,
                        time: this.duration,
                        player: this
                    });

                    this.pause();

                    this.onComplete.dispatch({
                        player: this
                    });
                } else {
                    this.onTime.dispatch({
                        duration: this.duration,
                        time: this.time,
                        player: this
                    });
                }
            }
        });

        if (options.notes) {
            this.notes = options.notes;
        }
    }

    public get state(): MelodyPlayerState {
        return this._state;
    }

    private setState(state: MelodyPlayerState): boolean {
        if (this._state === state) {
            return false;
        }
        this._state = state;
        return true;
    }

    public get virtual(): MelodyPlayerListener {
        return this._virtual;
    }

    public set virtual(value: MelodyPlayerListener) {
        if (this._virtual === value) {
            return;
        }
        this._virtual = value;
    }

    public get visual(): MelodyPlayerListener {
        return this._visual;
    }

    public set visual(value: MelodyPlayerListener) {
        if (this._visual === value) {
            return;
        }
        this._visual = value;
    }

    public toggle(): void {
        if (this._state === "playing") {
            this.pause();
        } else {
            this.play();
        }
    }

    public get duration(): number {
        return this._duration;
    }

    public get time(): number {

        if (!this._notes) {
            return 0;
        }

        if (this._state === "paused") {
            return this._startOffset;
        }

        return Math.min(
            (Tone.Transport.seconds - this._startTime) + this._startOffset,
            this.duration);
    }

    public set time(value: number) {

        if (!this._notes) {
            this._startOffset = 0;
            return;
        }

        value = e5.Calc.clamp(value, 0, this.duration);

        if (this._state === "paused") {
            this._startOffset = value;
            return;
        }

        // this._part.stop(Tone.Transport.seconds + 0.05);
        this._part.stop(0);
        this._part.cancel();
        this._startTime = Tone.Transport.seconds + 0.1;
        this._startOffset = value;
        this._part.start(this._startTime, this._startOffset);
        // console.log("SET TIME", value);
    }

    public play(): void {
        if (this._state === "playing") {
            console.log("SKIPPED PLAYING, IS ALREADY PLAYING");
            return;
        }

        // this._part.cancel();
        this._startTime = Tone.Transport.seconds + 0.1;
        this._part.start(this._startTime, this._startOffset);

        // console.log("Play@", this._startTime, this._startOffset);

        this.setState("playing");
    }

    public pause(): void {
        if (this._state === "paused") {
            return;
        }

        this._startOffset = this.time;
        this._part.stop(0);
        this.setState("paused");
    }

    public stop():void{
        this.pause();
        this.time = 0;
    }

    public get notes(): VOMelodyNote[] {
        return this._notes;
    }

    public set notes(value: VOMelodyNote[]) {
        if (this._notes === value) {
            return;
        }

        this._startOffset = 0;

        if (this._state === "playing") {
            this._part.stop(0);
            this._part.cancel();
        }

        this._notes = value;

        if (value) {
            //@ts-ignore
            this._part.clear();

            this._duration = value[value.length - 1].time + value[value.length - 1].dur;

            for (var note of value) {
                this._part.add(note.time, note);
            }

            if (this._state === "playing") {
                this.time = 0;
            }


        } else {
            //@ts-ignore
            this._part.clear();
            if (this._state === "playing") {
                this._state = "paused";
            }
        }
    }
}